module.exports = __webpack_public_path__ + "img/axbz.7a7883d0.png";